const env = process.env.REACT_APP_ENV || 'dev';

export const environment = {
  env,
  apiBaseURLClients: process.env.REACT_APP_API_BASE_URL_CLIENTS,
  disableAuth: process.env.REACT_APP_DISABLE_AUTH === 'true',
  clientPortalUrl: `https://clientes.${env}.busifarm.com.br`,
};
